(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["annoucement"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('ecida-announcement-bar')) {
    customElements.define('ecida-announcement-bar', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.ecida-announcement__viewport');
        this.items = Array.from(this.querySelectorAll('.ecida-announcement__item'));
        if (!this.items.length) { this.hidden = true; return; }
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.hovered = false;
        this.focused = false;
        this.editing = false;
        this.motion.addEventListener('change', () => this.restart(), options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.syncPlayback(); }
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false; this.syncPlayback();
        }, options);
        this.viewport.addEventListener('focusin', () => {
          this.focused = true;
          if (this.animation) this.animation.currentTime = this.duration / 2;
          this.syncPlayback();
        }, options);
        this.viewport.addEventListener('focusout', () => {
          this.focused = false; this.syncPlayback();
        }, options);
        this.querySelector('.ecida-announcement__close')?.addEventListener('click', () => {
          this.hidden = true;
          this.animation?.cancel();
          clearTimeout(this.timer);
          this.updateOffset();
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.ecida-announcement__item');
          const index = this.items.indexOf(item);
          if (index < 0) return;
          this.editing = true;
          this.show(index);
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.editing = false; this.show(this.index);
        }, options);
        this.observer = new ResizeObserver(() => {
          this.updateOffset();
          if (this.viewport.clientWidth !== this.lastWidth) this.restart();
        });
        this.setAttribute('data-ready', '');
        this.updateOffset();
        this.show(0);
        this.observer.observe(this.viewport);
        document.fonts.ready.then(() => { if (this.isConnected) this.restart(); });
      }
      restart() {
        if (this.hidden) return;
        const progress = this.animation && this.duration ? Number(this.animation.currentTime || 0) / this.duration : 0;
        this.show(this.index, progress);
      }
      show(index, progress = 0) {
        this.animation?.cancel();
        clearTimeout(this.timer);
        this.index = index;
        this.items.forEach((item, i) => {
          item.toggleAttribute('data-active', i === index);
          item.setAttribute('aria-hidden', String(i !== index));
          item.style.removeProperty('transform');
        });
        const item = this.items[index];
        const viewportWidth = this.viewport.clientWidth;
        const itemWidth = item.getBoundingClientRect().width;
        this.lastWidth = viewportWidth;
        if (!viewportWidth || !itemWidth) return;
        if (this.motion.matches || this.editing) {
          item.style.transform = 'translateY(0)';
          this.animation = null;
          this.syncPlayback();
          return;
        }
        const hold = Math.max(2, Math.min(10, Number(this.dataset.hold) || 3)) * 1000;
        const transition = 400;
        this.duration = hold + transition * 2;
        this.animation = item.animate([
          { transform: 'translateY(100%)', offset: 0, easing: 'cubic-bezier(.22, 1, .36, 1)' },
          { transform: 'translateY(0)', offset: transition / this.duration },
          { transform: 'translateY(0)', offset: (transition + hold) / this.duration, easing: 'cubic-bezier(.64, 0, .78, 0)' },
          { transform: 'translateY(-100%)', offset: 1 }
        ], { duration: this.duration, easing: 'linear', fill: 'both' });
        this.animation.currentTime = Math.min(.999, Math.max(0, progress)) * this.duration;
        this.animation.onfinish = () => {
          if (this.isConnected && !this.hidden) this.show((this.index + 1) % this.items.length);
        };
        this.syncPlayback();
      }
      syncPlayback() {
        clearTimeout(this.timer);
        const paused = this.hovered || this.focused || this.editing || this.hidden;
        if (this.animation) {
          if (paused) this.animation.pause();
          else this.animation.play();
        } else if (!paused && this.motion.matches && this.items.length > 1) {
          const hold = Math.max(2, Math.min(10, Number(this.dataset.hold) || 3)) * 1000;
          this.timer = setTimeout(() => this.show((this.index + 1) % this.items.length), hold);
        }
      }
      updateOffset() {
        const height = this.hidden ? 0 : this.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--ecida-announcement-offset', height + 'px');
        document.documentElement.style.setProperty('--m-announcement-height', height + 'px');
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.animation?.cancel();
        clearTimeout(this.timer);
        document.documentElement.style.removeProperty('--ecida-announcement-offset');
        document.documentElement.style.setProperty('--m-announcement-height', '0px');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
